/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FeedBackTypeEnum } from './feedBackTypeEnum';
import { GeneralFeedbackEventTypeEnum } from './generalFeedbackEventTypeEnum';


export interface FeedbackDtos { 
    id: string;
    creatorId?: string;
    serviceProvidername?: string;
    serviceName?: string;
    shortCode?: string;
    serverMessage?: string;
    description?: string;
    dateCreated: Date;
    answerType?: string;
    expiryDate: Date;
    phoneNumber?: string;
    contentName?: string;
    serviceTypeName?: string;
    generalFeedbackEventType: GeneralFeedbackEventTypeEnum;
    feedbackType: FeedBackTypeEnum;
}
